import React, { Component } from "react";
import axios from "axios";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { Message, MessageBox } from "element-react";
import Clock from "react-live-clock";
import Modal from "react-bootstrap/Modal";
import AS from "../../Login/Service/Authentication";
import MS from "../../../commons/services/Moment";
import CS from "../../../commons/services/Common";
import PS from "./../MonitoringApiService";
import BarChart from "../../../commons/components/BarChart";
import LineChart from "../../../commons/components/LineChart";
import RawData from "./../RawData";

/**
 * 발전소 세부 컴포넌트
 */
class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plantId: props.match.params.plantId,
      plantInfo: [],
      refreshSeconds: 90,
      refreshStandard: 100 / 90,
      inverterSerialNos: [],
      combinerSerialNos: [],
      currentHourPower: 0,
      currentHour: 0,

      todayPowerTime: 0,
      todayPower: 0,
      todayProfit: 0,
      lastMonthPowerTime: 0,
      lastMonthPower: 0,
      lastMonthProfit: 0,
      thisMonthPowerTime: 0,
      thisMonthPower: 0,
      thisMonthProfit: 0,
      thisYearPowerTime: 0,
      thisYearPower: 0,
      thisYearProfit: 0,
      accumulationPowerTime: 0,
      accumulationPower: 0,
      accumulationProfit: 0,

      chartData: [],
      ymChartData: [],
      quarterChartData: [],
      yChartData: [],
      chartTodayHourlyData: [],
      info: {},

      isModalShow: false,
      isDisabled: "disabled",
      isDailyDisabled: "disabled",
      isCumulativeDisabled: "",
      dailyYear: MS.format(new Date(), "YYYY"),
      dailyMonth: MS.format(new Date(), "MM"),
      dailyDay: MS.format(new Date(), "DD"),

      year: MS.format(new Date(), "YYYY"),
      month: MS.format(new Date(), "MM"),

      cumulativeFromYear: Number(MS.format(new Date(), "YYYY")) - 1,
      cumulativeToYear: Number(MS.format(new Date(), "YYYY")),
      activeTab: "ym",

      todayPowerTime: 0,
      dayPower: 0,
      monthPower: 0,
      totalPower: 0,
    };

    this.timer = 0;
    this.handleModal = this.handleModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    this.checkUserApprove();
    this.getPlantInfo();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  startTimer = () => {
    if (this.timer == 0 && this.state.refreshSeconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  countDown = () => {
    const seconds = this.state.refreshSeconds - 1;
    this.setState({
      refreshSeconds: seconds,
    });
    if (seconds === 0) this.getData();
  };

  async getPlantInfo() {
    const { plantId, inverterSerialNos } = this.state;
    if (inverterSerialNos.length == 0) {
      const res = await axios.get(
        `/usr/api/user-plant/info?plantIds=${plantId}`
      );
      this.setState({
        info: res.data[0],
      });
      const plantInfos = AS.getLoggedInPlantInfos();
      let filteredPlantInfo = plantInfos.filter((v) => v.id == plantId);
      const inverterSerialNos = CS.getKeyValues(
        filteredPlantInfo[0].invs,
        "serialNo"
      );
      const combinerSerialNos = CS.getKeyValues(
        filteredPlantInfo[0].invs,
        "combinerSerialNo"
      );
      this.setState({
        inverterSerialNos: inverterSerialNos,
        combinerSerialNos: combinerSerialNos,
        plantInfo: filteredPlantInfo,
      });
    }

    this.getData();
    const currentHour = Number(MS.format(new Date(), "HH"));
    if (currentHour >= 7 && currentHour <= 18) {
      this.startTimer();
    } else {
      clearInterval(this.timer);
    }
    this.setState({
      currentHour: currentHour,
    });
  }

  getData = async () => {
    const { plantInfo, inverterSerialNos, cumulativeToYear, activeTab } =
      this.state;
    const currentHourPowerList = await PS.getAccumulationPowerList({
      inverterSerialNos: inverterSerialNos,
      fromDate: MS.format(new Date(), "YYYY-MM-DD HH:00:00"),
      toDate: MS.format(new Date(), "YYYY-MM-DD HH:mm:ss"),
    });
    let currentHourPower = 0;
    currentHourPowerList.some((v) => {
      currentHourPower += v.lastPower - v.firstPower;
    });
    this.setState({
      currentHourPower: currentHourPower,
    });

    this.getAccumulationPower(inverterSerialNos);
    this.getTodayPower(inverterSerialNos);
    this.getLastMonthPower(inverterSerialNos);
    this.getThisMonthPower(inverterSerialNos);
    this.getThisYearPower(inverterSerialNos);
    this.getTodayHourlyPower(MS.current("YYYY-MM-DD"), inverterSerialNos);
    this.getDailyPower(MS.current("YYYY-MM"), inverterSerialNos);
    this.getAccumulationPowerForChart(
      cumulativeToYear,
      activeTab,
      inverterSerialNos
    );
    this.setState({
      refreshSeconds: 90,
    });
  };

  getAccumulationPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      inverterSerialNos: inverterSerialNos,
    };
    const inverterData = await PS.getLatestInverter(param);
    const days =
      MS.diff(info.operationStartDt, MS.current("YYYY-MM-DD"), "days") + 1;
    const accumulationPower = PS.getPowerByInverter(
      inverterData,
      "accumulationPower"
    );
    this.setState({
      accumulationPower: accumulationPower,
      accumulationPowerTime:
        accumulationPower / info.installationCapacity / days,
      accumulationProfit: accumulationPower * info.unitPrice,
    });
  };

  getTodayPower = async (inverterSerialNos) => {
    const { info, currentHourPower } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ymd",
      date: MS.current("YYYY-MM-DD"),
      groupCols: ["ymd"],
    };
    const todayPower = (await PS.getTodayPower(param)) + currentHourPower;
    this.setState({
      todayPower: todayPower,
      todayPowerTime: todayPower / info.installationCapacity,
      todayProfit: todayPower * info.unitPrice,
    });
  };

  getLastMonthPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: MS.addAndFormat(new Date(), -1, "months", "YYYY-MM"),
      groupCols: ["ym"],
    };
    const lastDays = parseInt(MS.endOf(MS.add(new Date(), -1, "months"), "D"));
    const lastMonthPower = await PS.getTodayPower(param);
    this.setState({
      lastMonthPower: lastMonthPower,
      lastMonthPowerTime: lastMonthPower / info.installationCapacity / lastDays,
      lastMonthProfit: lastMonthPower * info.unitPrice,
    });
  };

  getThisMonthPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: MS.current("YYYY-MM"),
      groupCols: ["ym"],
    };
    const days = parseInt(MS.current("D"));
    const thisMonthPower =
      (await PS.getTodayPower(param)) + this.state.currentHourPower;
    this.setState({
      thisMonthPower: thisMonthPower,
      thisMonthPowerTime: thisMonthPower / info.installationCapacity / days,
      thisMonthProfit: thisMonthPower * info.unitPrice,
    });
  };

  getThisYearPower = async (inverterSerialNos) => {
    const { info } = this.state;
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "y",
      date: MS.current("YYYY"),
      groupCols: ["y"],
    };
    const days =
      MS.diff(
        MS.startOf(new Date(), "year", "YYYY-MM-DD"),
        MS.current("YYYY-MM-DD"),
        "days"
      ) + 1;
    const thisYearPower =
      (await PS.getTodayPower(param)) + this.state.currentHourPower;
    this.setState({
      thisYearPower: thisYearPower,
      thisYearPowerTime: thisYearPower / info.installationCapacity / days,
      thisYearProfit: thisYearPower * info.unitPrice,
    });
  };

  getTodayHourlyPower = async (date, inverterSerialNos) => {
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ymd",
      date: date,
      groupCols: ["hh"],
    };
    const hours = PS.getHourlyAxisx(date);
    const hourlyPower = await PS.getPowerList(param);

    if (date === MS.format(new Date(), "YYYY-MM-DD")) {
      hourlyPower.push({
        _id: MS.format(new Date(), "HH"),
        power: this.state.currentHourPower,
      });
    }

    const data = PS.settingChartData(hours, hourlyPower);
    const chartData = {};
    chartData.labels = hours;
    chartData.datasets = data;
    this.setState({
      chartTodayHourlyData: chartData,
    });
  };

  getDailyPower = async (ym, inverterSerialNos) => {
    const param = {
      isPeriod: false,
      inverterSerialNos: inverterSerialNos,
      dateType: "ym",
      date: ym,
      groupCols: ["ymd"],
    };
    const dailyPowerList = await PS.getPowerList(param);
    const index = dailyPowerList.findIndex((e, index, array) => {
      return e._id === MS.current("YYYY-MM-DD");
    });
    if (index > -1) {
      dailyPowerList[index].power =
        dailyPowerList[index].power + this.state.currentHourPower;
    }
    const labels = PS.getDailyAxisx(ym);
    const data = PS.settingChartData(labels, dailyPowerList);
    const chartData = {};
    chartData.labels = labels;
    chartData.datasets = data;
    this.setState({
      chartData: chartData,
    });
  };

  getAccumulationPowerForChart = async (y, activeTab, inverterSerialNos) => {
    let chartDatas = [];
    for (let i = 0; i < 2; i++) {
      const param = {
        isPeriod: false,
        inverterSerialNos: inverterSerialNos,
        dateType: "y",
        date: y - i,
        groupCols: [activeTab],
      };
      const powerList = await PS.getPowerList(param);

      let index = -1;
      const chartLabels = [];
      let labels = [];
      if (activeTab === "ym") {
        labels = PS.getMonthlyAxisx(y - i);
        labels.some((v) => {
          chartLabels.push(Number(v.substring(5)));
        });
        index = powerList.findIndex((e, index, array) => {
          return e._id === MS.current("YYYY-MM");
        });
      } else if (activeTab === "quarter") {
        labels = ["1", "2", "3", "4"];
        labels.some((v) => {
          chartLabels.push(v);
        });
        index = powerList.findIndex((e, index, array) => {
          return e._id === MS.currentQuarter();
        });
      } else {
        labels = [(y - i).toString()];
        chartLabels.push((y - i).toString());
        index = powerList.findIndex((e, index, array) => {
          return e._id === MS.current("YYYY");
        });
      }

      if (index > -1) {
        powerList[index].power =
          Number(powerList[index].power) + this.state.currentHourPower;
      }

      const data = PS.settingChartData(labels, powerList);
      const chartData = {};
      chartData.labels = chartLabels;
      chartData.datasets = data;
      chartDatas.push(chartData);
    }

    if (activeTab === "y") {
      const yLabel = [];
      const yDatasets = [];
      chartDatas.some((v) => {
        yLabel.push(v.labels[0]);
        yDatasets.push(v.datasets[0]);
      });
      chartDatas.labels = yLabel;
      chartDatas.datasets = yDatasets;
    }

    this.setState({
      [activeTab + "ChartData"]: chartDatas,
    });
  };

  async checkUserApprove() {
    let res = await axios.get(
      `/cst/api/constructor-plant/user-approve-check/${this.state.plantId}`
    );
    if (res.data.result) {
      MessageBox.confirm(
        "해당 발전소를 모니터링 하고자 하는 사용자가 존재합니다. 모니터링을 승인하시겠습니까?",
        "알림",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "info",
        }
      )
        .then(() => {
          axios
            .patch(
              `/cst/api/constructor-plant/approve-user-plant/${this.state.plantId}`
            )
            .then((res) => {
              Message({
                type: "success",
                message: "승인 되었습니다.",
              });
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "취소 되었습니다.",
          });
        });
    }
  }

  tabClickHandler = (id) => {
    this.setState({
      activeTab: id,
    });
    this.getAccumulationPowerForChart(
      this.state.cumulativeToYear,
      id,
      this.state.inverterSerialNos
    );
  };

  clickDateHandler = (gubun, step) => {
    if (gubun === "daily") {
      let { dailyYear, dailyMonth, dailyDay, inverterSerialNos } = this.state;
      const calcDay = MS.addAndFormat(
        dailyYear + dailyMonth + dailyDay,
        step === "+" ? 1 : -1,
        "days",
        "YYYY-MM-DD"
      );
      dailyYear = MS.format(calcDay, "YYYY");
      dailyMonth = MS.format(calcDay, "MM");
      dailyDay = MS.format(calcDay, "DD");
      this.setState({
        dailyYear: dailyYear,
        dailyMonth: dailyMonth,
        dailyDay: dailyDay,
        isDailyDisabled:
          dailyYear + dailyMonth + dailyDay < MS.format(new Date(), "YYYYMMDD")
            ? ""
            : "disabled",
      });
      this.getTodayHourlyPower(calcDay, inverterSerialNos);
    } else if (gubun === "cumulative") {
      let fromYear = this.state.cumulativeFromYear;
      let toYear = this.state.cumulativeToYear;
      fromYear = step === "+" ? fromYear + 1 : fromYear - 1;
      toYear = step === "+" ? toYear + 1 : toYear - 1;
      this.setState({
        cumulativeFromYear: fromYear,
        cumulativeToYear: toYear,
        isCumulativeDisabled:
          fromYear < MS.format(new Date(), "YYYY") ? "" : "disabled",
      });
      this.getAccumulationPowerForChart(
        toYear,
        this.state.activeTab,
        this.state.inverterSerialNos
      );
    } else {
      let year = this.state.year;
      let month = this.state.month;
      year = MS.addAndFormat(
        year + month + "01",
        step === "+" ? 1 : -1,
        "months",
        "YYYY"
      );
      month = MS.addAndFormat(
        year + month + "01",
        step === "+" ? 1 : -1,
        "months",
        "MM"
      );
      this.setState({
        year: year,
        month: month,
        isDisabled:
          year + month < MS.format(new Date(), "YYYYMM") ? "" : "disabled",
      });
      this.getDailyPower(year + "-" + month, this.state.inverterSerialNos);
    }
  };

  getChartDataSets(data) {
    let datasets = [];
    let dataset = {
      label: ["발전량"],
      backgroundColor: "#d6f71a",
      borderColor: "#c5e319",
      borderWidth: 2,
      data: data,
    };
    datasets.push(dataset);
    return datasets;
  }

  getMultiChartDataSets(data, cnt) {
    let datasets = [];
    for (let i = 0; i < cnt; i++) {
      let dataset = {
        label: Number(this.state.cumulativeToYear) - i,
        backgroundColor: i == 0 ? "#d6f71a" : "#eefc9a",
        borderColor: i == 0 ? "#c5e319" : "#e4fa64",
        borderWidth: 2,
        order: 2 - i,
        data: data[i].datasets,
      };
      datasets.push(dataset);
    }
    return datasets;
  }

  getLineChartDataSets(data) {
    let datasets = [];
    let dataset = {
      label: ["발전량(W)"],
      fill: false,
      lineTension: 0.3,
      backgroundColor: "rgba(214,247,26,0.4)",
      borderColor: "#d6f71a",
      borderCapStyle: "butt",
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: "miter",
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 3,
      pointHitRadius: 10,
      data: data,
    };
    datasets.push(dataset);
    return datasets;
  }

  handleModal() {
    this.setState({
      isModalShow: true,
    });
  }
  handleCloseModal() {
    this.setState({
      isModalShow: false,
    });
  }

  formatSize(size) {
    if (size > 1000) {
      return size / 1000;
    }
    return size;
  }

  formatUnit(size) {
    if (size > 1000) {
      return "MWh";
    }
    return "kWh";
  }

  render() {
    const {
      isModalShow,
      refreshSeconds,
      refreshStandard,
      info,
      plantId,
      isDisabled,
      isDailyDisabled,
      currentHour,
      year,
      month,
      dailyYear,
      dailyMonth,
      dailyDay,
      cumulativeFromYear,
      cumulativeToYear,
      activeTab,
      todayPower,
      lastMonthPower,
      thisMonthPower,
      thisYearPower,
      accumulationPower,
      todayPowerTime,
      lastMonthPowerTime,
      thisMonthPowerTime,
      thisYearPowerTime,
      accumulationPowerTime,
      todayProfit,
      lastMonthProfit,
      thisMonthProfit,
      thisYearProfit,
      accumulationProfit,
      chartData,
      ymChartData,
      quarterChartData,
      yChartData,
      chartTodayHourlyData,
      inverterSerialNos,
      combinerSerialNos,
      isCumulativeDisabled,
    } = this.state;
    return (
      <>
        <div className="page-tit">
          <div className="container location">
            <h2 className="tit">전체 발전소 리스트</h2>
            <span>
              <strong>발전소 세부정보</strong>
            </span>
          </div>
        </div>
        <section className="power-plant-title">
          <div className="container">
            <div className="h-stack top">
              <div>
                <h2 className="name">
                  {info.name}
                  <Link to={"/plant-list/update/" + plantId} className="edit">
                    <img src="/images/ctors/icon/btn/edit.png" alt="편집" />
                  </Link>
                  {/* <Link to={"/plant-list/equip/" + plantId} className="edit">
                    <img src="/images/ctors/icon/btn/edit.png" alt="편집" />
                  </Link>
                  <i className="material-icons" onClick={this.handleModal}>
                    <EqualizerIcon style={{ fontSize: 40, color: "#bfcbd9" }} />
                  </i> */}
                </h2>
                <p className="addr">{info.address}</p>
                <div className="counter">
                  <strong className="tit">
                    <font size="2">설비용량</font>
                  </strong>
                  <strong className="num">
                    <font size="3">{info.installationCapacity}</font>
                  </strong>{" "}
                  <strong className="unit">
                    <font size="2">kW</font>
                  </strong>
                </div>
                <div className="counter">
                  <strong className="tit">총 누적 발전량 </strong>
                  <strong className="num">
                    <CountUp
                      start={0}
                      end={this.formatSize(accumulationPower)}
                      decimals={2}
                      duration={3.5}
                      separator=","
                    />
                  </strong>
                  &nbsp;
                  <strong className="unit">
                    {this.formatUnit(accumulationPower)}
                  </strong>
                </div>
              </div>
              <div className="wp45">
                <Link
                  to={
                    plantId == 109
                      ? `/plant-status/issue/detail/${plantId}`
                      : `/plant-status/issue/detail-ov/${plantId}`
                  }
                  className="btn secondary wp45 radius15"
                >
                  발전소 모듈 체크하기
                </Link>
                &nbsp;
                <a
                  onClick={() =>
                    window.open("/plant-status/detail/inverter/" + plantId)
                  }
                  target="_blank"
                  className="btn secondary wp45 radius15"
                >
                  인버터 데이터
                </a>
                {/*
                                    combinerSerialNos.length > 0
                                    ?   <><Link to={"/plant-status/issue/combiner/" + plantId} className="btn secondary wp100 radius15">접속반 체크하기</Link></>
                                    :   <Link to={"/plant-status/issue/detail/" + plantId} className="btn secondary wp100 radius15">발전소 모듈 체크하기</Link>
                                */}
              </div>
            </div>
          </div>
        </section>

        <section className="power-plant-count">
          <div className="container">
            <h3 className="content-tit1">발전정보</h3>
            <div className="card2">
              <div className="h-stack center">
                <div>
                  <h5 className="tit">금일 발전량</h5>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={todayPower}
                        decimals={0}
                        duration={0.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;kWh
                  </p>
                </div>
                <div>
                  <h5 className="tit">이전월 발전량</h5>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={this.formatSize(lastMonthPower)}
                        decimals={2}
                        duration={1}
                        separator=","
                      />
                    </strong>
                    &nbsp;{this.formatUnit(lastMonthPower)}
                  </p>
                </div>
                <div>
                  <h5 className="tit">당월 발전량</h5>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={this.formatSize(thisMonthPower)}
                        decimals={2}
                        duration={1.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;{this.formatUnit(thisMonthPower)}
                  </p>
                </div>
                <div>
                  <h5 className="tit">금년 발전량</h5>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={this.formatSize(thisYearPower)}
                        decimals={2}
                        duration={2.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;{this.formatUnit(thisYearPower)}
                  </p>
                </div>
                <div>
                  <h5 className="tit">누적 발전량</h5>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={this.formatSize(accumulationPower)}
                        decimals={2}
                        duration={3.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;{this.formatUnit(accumulationPower)}
                  </p>
                </div>
              </div>
              <br />
              <div className="h-stack center">
                <div>
                  <h4 className="tit">금일 발전시간</h4>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={todayPowerTime}
                        decimals={2}
                        duration={0.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;h
                  </p>
                </div>
                <div>
                  <h4 className="tit">이전월 발전시간</h4>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={lastMonthPowerTime}
                        decimals={2}
                        duration={1}
                        separator=","
                      />
                    </strong>
                    &nbsp;h
                  </p>
                </div>
                <div>
                  <h4 className="tit">당월 발전시간</h4>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={thisMonthPowerTime}
                        decimals={2}
                        duration={1.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;h
                  </p>
                </div>
                <div>
                  <h4 className="tit">금년 발전시간</h4>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={thisYearPowerTime}
                        decimals={2}
                        duration={2.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;h
                  </p>
                </div>
                <div>
                  <h4 className="tit">누적 발전시간</h4>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={accumulationPowerTime}
                        decimals={2}
                        duration={3.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;h
                  </p>
                </div>
              </div>
              <br />
              <div className="h-stack center">
                <div>
                  <h3 className="tit">금일 발전수익</h3>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={todayProfit}
                        duration={0.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;원
                  </p>
                </div>
                <div>
                  <h3 className="tit">이전월 발전수익</h3>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={lastMonthProfit}
                        duration={1}
                        separator=","
                      />
                    </strong>
                    &nbsp;원
                  </p>
                </div>
                <div>
                  <h3 className="tit">당월 발전수익</h3>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={thisMonthProfit}
                        duration={1.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;원
                  </p>
                </div>
                <div>
                  <h3 className="tit">금년 발전수익</h3>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={thisYearProfit}
                        duration={2.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;원
                  </p>
                </div>
                <div>
                  <h3 className="tit">누적 발전수익</h3>
                  <p className="txt">
                    <strong className="num">
                      <CountUp
                        start={0}
                        end={accumulationProfit}
                        duration={3.5}
                        separator=","
                      />
                    </strong>
                    &nbsp;원
                  </p>
                </div>
              </div>
              <div className="foot">
                <h3 className="inline tit">현재시각</h3>
                <h4 className="inline tit">
                  <font color="#6255d7">
                    <Clock
                      format={"YYYY.MM.DD HH:mm:ss"}
                      ticking={true}
                      timezone={"Asia/Seoul"}
                    />
                  </font>
                </h4>
                {currentHour >= 7 && currentHour <= 18 && (
                  <>
                    <br />
                    <br />
                    <ProgressBar
                      animated
                      variant="custom-progressbar-color-red"
                      label={`${refreshSeconds}초`}
                      now={refreshSeconds * refreshStandard}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <br />
        <section className="power-plant-graph">
          <div className="container">
            <div className="f-stack">
              <h3 className="content-tit1">시간별 발전량 그래프(단위, kWh)</h3>
              <div className="pr-25">
                <div className="chart-caption">
                  <i className="circle-bg"></i>
                  <strong className="mx-10">발전량</strong>
                  <span className="tool-tip right">
                    <span className="text w350">
                      해당 그래프는 오늘 하루 시간때별로 발전된 발전량 정보를
                      제공합니다.
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="card graph">
              <div className="calendar">
                <div className="control">
                  <button
                    type="button"
                    className="prev"
                    onClick={() => this.clickDateHandler("daily", "-")}
                  ></button>
                  <strong className="date">
                    <span className="year">{Number(dailyYear)}</span>
                    <span className="month">{Number(dailyMonth)}</span>&nbsp;
                    <span className="day">{Number(dailyDay)}</span>
                  </strong>
                  <button
                    type="button"
                    className="next"
                    onClick={() => this.clickDateHandler("daily", "+")}
                    disabled={isDailyDisabled}
                  ></button>
                </div>
              </div>
              <div className="chart">
                {!CS.checkIsEmptyObject(chartTodayHourlyData) ? (
                  <LineChart
                    text="발전량 그래프(단위, kWh)"
                    labels={chartTodayHourlyData.labels}
                    datasets={this.getLineChartDataSets(
                      chartTodayHourlyData.datasets
                    )}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="f-stack mt-30">
              <h3 className="content-tit1">일자별 발전량 그래프(단위, kWh)</h3>
              <div className="pr-25">
                <div className="chart-caption">
                  <i className="circle-bg"></i>
                  <strong className="mx-10">발전량</strong>
                  <span className="tool-tip right">
                    <span className="text w350">
                      해당 그래프는 한달동안 일별로 발전된 시간당 발전량 정보를
                      제공합니다.
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="card graph">
              <div className="calendar">
                <div className="control">
                  <button
                    type="button"
                    className="prev"
                    onClick={() => this.clickDateHandler("", "-")}
                  >
                    <strong>이전달</strong>
                  </button>
                  <strong className="date">
                    <span className="year">{year}</span>
                    <span className="month">{month}</span>
                  </strong>
                  <button
                    type="button"
                    className="next"
                    onClick={() => this.clickDateHandler("", "+")}
                    disabled={isDisabled}
                  >
                    <strong>다음달</strong>
                  </button>
                </div>
              </div>
              <div className="chart" id="powerPlantGraph">
                {!CS.checkIsEmptyObject(chartData) ? (
                  <BarChart
                    text="발전량 그래프(단위, kWh)"
                    labels={chartData.labels}
                    datasets={this.getChartDataSets(chartData.datasets)}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="f-stack mt-30">
              <h3 className="content-tit1">누적 발전량 그래프(단위, kWh)</h3>
              <div className="pr-25">
                <div className="calendar sm gray">
                  <div className="control">
                    <button
                      type="button"
                      className="prev"
                      onClick={() => this.clickDateHandler("cumulative", "-")}
                    >
                      <strong>이전달</strong>
                    </button>
                    <strong className="date">
                      <span className="year">{cumulativeFromYear}</span>
                      <span className="year">{cumulativeToYear}</span>
                    </strong>
                    <button
                      type="button"
                      className="next"
                      onClick={() => this.clickDateHandler("cumulative", "+")}
                      disabled={isCumulativeDisabled}
                    >
                      <strong>다음달</strong>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card cumulative-power">
              <div id="chartTabPanel" className="tabs-wrapper">
                <nav className="tab-menu">
                  <a
                    onClick={() => this.tabClickHandler("ym")}
                    className={activeTab == "ym" ? "active" : ""}
                  >
                    월간
                  </a>
                  <a
                    onClick={() => this.tabClickHandler("quarter")}
                    className={activeTab == "quarter" ? "active" : ""}
                  >
                    분기
                  </a>
                  <a
                    onClick={() => this.tabClickHandler("y")}
                    className={activeTab == "y" ? "active" : ""}
                  >
                    연간
                  </a>
                </nav>
                <div className="tab-contents">
                  <div
                    id="tabs-1"
                    className="tab-panel"
                    style={
                      activeTab == "ym"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {!CS.checkIsEmptyObject(ymChartData) ? (
                      <BarChart
                        id="powerPlantMonth"
                        text="누적 발전량(월간)"
                        labels={ymChartData[0].labels}
                        datasets={this.getMultiChartDataSets(ymChartData, 2)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    id="tabs-2"
                    className="tab-panel"
                    style={
                      activeTab == "quarter"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {!CS.checkIsEmptyObject(quarterChartData) ? (
                      <BarChart
                        id="powerPlantQuarter"
                        text="누적 발전량(분기별)"
                        labels={quarterChartData[0].labels}
                        datasets={this.getMultiChartDataSets(
                          quarterChartData,
                          2
                        )}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    id="tabs-3"
                    className="tab-panel"
                    style={
                      activeTab == "y"
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    {!CS.checkIsEmptyObject(yChartData) ? (
                      <BarChart
                        id="powerPlantYear"
                        text="누적 발전량(연간)"
                        labels={yChartData.labels}
                        datasets={this.getChartDataSets(yChartData.datasets)}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <hr className="style1"></hr>
        <section>
          <div className="container">
            <h3 className="content-tit1">
              <i className="material-icons file">folder</i> 파일 다운로드
            </h3>
            <div className="f-stack spacing25">
              <button
                type="button"
                className="btn white wp100"
                onClick={() => CS.fileDown(info.oneLineDiagramFileId)}
              >
                단선결선도 파일
              </button>
              <button
                type="button"
                className="btn white wp100"
                onClick={() => CS.fileDown(info.floorPlanFileId)}
              >
                도면 파일
              </button>
              <button
                type="button"
                className="btn white wp100"
                onClick={() => CS.fileDown(info.serialNoFileId)}
              >
                모듈 인버터 시리얼번호 엑셀파일
              </button>
            </div>
            <h3 className="content-tit1">기본 정보</h3>
            <div className="card2">
              <div className="f-stack form-view">
                <div className="wp50">
                  <span className="tit">운전 개시일</span>
                  <strong>{info.operationStartDt}</strong>
                  <small className="size13 ml-10">{info.diff}</small>
                </div>
                <div className="wp50">
                  <span className="tit">사업주 명</span>
                  <strong>{info.ownerName}</strong>
                </div>
              </div>
            </div>

            <h3 className="content-tit1">태양광 설비 세부 정보</h3>
            <div className="card2">
              <table className="style1">
                <colgroup>
                  <col style={{ width: "16%" }} />
                  <col />
                  <col style={{ width: "18%" }} />
                  <col style={{ width: "14%" }} />
                  <col style={{ width: "14%" }} />
                  <col style={{ width: "18%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th className="left">태양광 모듈 &gt;</th>
                    <td>{info.moduleCorpName}</td>
                    <td>{info.moduleModelName}</td>
                    <td>{info.installationCnt} 장</td>
                    <td>{info.installationCapacity} W</td>
                    <td>{info.moduleCorpPhone}</td>
                  </tr>
                  <tr>
                    <th className="left">인버터 &gt;</th>
                    <td>{info.inverterCorpName}</td>
                    <td>{info.inverterModelName}</td>
                    <td>{inverterSerialNos.length}대</td>
                    <td></td>
                    <td>{info.inverterCorpPhone}</td>
                  </tr>
                  <tr>
                    <th className="left">구조물 &gt;</th>
                    <td>{info.structureName}</td>
                    <td>용용아연 철</td>
                    <td></td>
                    <td></td>
                    <td>{info.structureBizTelNum}</td>
                  </tr>
                  <tr>
                    <th className="left">전기 공사 &gt;</th>
                    <td>{info.electricWorkBizName}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{info.electricWorkBizTelNum}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <Modal
          show={isModalShow}
          size="lg"
          dialogClassName="modal-100w"
          onHide={this.handleCloseModal}
        >
          <Modal.Header closeButton style={{ background: "#bfcbd9" }}>
            <Modal.Title id="example-custom-modal-styling-title">
              <h3 className="tit">{info.name}</h3>
            </Modal.Title>
            <h4 className="tit">
              <Clock
                format={"YYYY.MM.DD HH:mm:ss"}
                ticking={true}
                timezone={"Asia/Seoul"}
              />
            </h4>
          </Modal.Header>
          <Modal.Body style={{ background: "#bfcbd9" }}>
            <>
              <RawData />
            </>
          </Modal.Body>
          <Modal.Footer style={{ background: "#bfcbd9" }}>
            <h4 className="tit">
              <Clock
                format={"YYYY.MM.DD HH:mm:ss"}
                ticking={true}
                timezone={"Asia/Seoul"}
              />
            </h4>
          </Modal.Footer>
        </Modal>

        <style jsx>
          {`
            .modal-lg {
              max-width: 1500px;
            }
            .bg-custom-progressbar-color-red {
              background: linear-gradient(90deg, var(--primary-500) 0%, var(--secondary-500) 100%) !important;
            }
          `}
        </style>
      </>
    );
  }
}

export default Main;
